'use strict';
module.exports = require('./Column.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/column/index.js
// module id = 5
// module chunks = 1